import { ICrudLocale } from '@app/i18n/interface';

export const DASHBOARD_KPIS_MANAGEMENT_LOCALE_EN: ICrudLocale = {
  KPI: {
    LABEL: {
      SINGULAR: 'Indicator',
      PLURAL: 'Indicators',
    },
    FIELD: {},
    TITLE: 'Activity in the period',
    SUBTITLE: 'Everything in this section counts only bookings created on the chosen dates.',
    EMPTY: 'No data for the chosen range.',
    RANGE: {
      LABEL: 'Dates',
      LAST_DAYS: 'Last {{ days }} days',
      TOO_LONG_TITLE: 'Range too wide',
      TOO_LONG_DESC: 'The range cannot exceed 366 days. Adjust the dates.',
    },
    CARD: {
      BOOKINGS: 'Bookings',
      BOOKINGS_NOTE: 'Created in the period, in any status.',
      REVENUE_SALE: 'Paid sales',
      REVENUE_NOTE: 'Paid bookings only;',
      REVENUE_MARKUP: 'Markup',
      NET_SHORT: 'net',
      MARGIN_OVER_SALE: 'of paid sales',
      CANCELLATION_SHORT: 'cancellations',
      CANCELLATION_BASE: 'of all bookings',
      REFUND_SHORT: 'refunds',
      REFUND_BASE: 'of paid ones',
      PAY_LATER_NOTE: '“Pay later” bookings cancelled without a charge count as cancelled. What is booked and still unpaid does not add to sales: see Collection forecast.',
      AVERAGE_TICKET: 'Average ticket',
    },
    CHART: {
      TITLE: 'Bookings per day',
      DESC: 'Bookings created each day (UTC day).',
      EMPTY: 'No bookings in the chosen range.',
      PEAK: 'Peak: {{ count }} a day',
    },
    STATUS_TABLE: {
      TITLE: 'Bookings by status',
      DESC: 'Bookings created in the period, by their current status.',
      STATUS: 'Status',
      BOOKINGS: 'Bookings',
    },
    TOP: {
      DESTINATIONS_TITLE: 'Top-selling destinations',
      HOTELS_TITLE: 'Top-selling hotels',
      ROOMS_DESC: 'Counts paid rooms, not bookings: a booking can hold several.',
      DESTINATION: 'Destination',
      HOTEL: 'Hotel',
      ITEM_BOOKINGS: 'Rooms',
      ROOMS: 'Rooms',
      REVENUE: 'Sales',
    },
    CAMPAIGNS: {
      TITLE: 'Sales by campaign',
      DESC: 'Paid bookings in the period, by where the visit that ended in a purchase came from.',
      SOURCE: 'Source',
      MEDIUM: 'Medium',
      CAMPAIGN: 'Campaign',
      SALES: 'Sales',
      REVENUE: 'Revenue',
      MARGIN: 'Markup',
      MARGIN_SHARE: 'Markup %',
      EMPTY: 'No bookings in these dates, so there are no sales to split by source.',
      HELP: 'Counts the same way as paid sales above: paid bookings (refunded ones included) created on the chosen dates. Bookings before 2 November 2026 and those from visitors who did not accept cookies show as “No attribution”. These figures need not match Google Analytics.',
      BUCKET: {
        NONE: 'No attribution',
        DIRECT: 'Direct',
        NOT_SET: 'Unidentified source',
        OTHERS: 'Others',
      },
    },
    ERROR: {
      TITLE: 'We could not load the indicators',
      DESC: 'The request failed. Try again in a moment.',
    },
  },
};
